import { z } from 'zod';
export const LocationSchema = z.object({
    id: z.number(),
    name: z.string(),
    is_active: z.boolean(),
});
//# sourceMappingURL=locations.js.map